import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isPromptBarActive: false,
};

const promptBarSlice = createSlice({
    name: 'promptBar',
    initialState,
    reducers: {
        setPromptBarActive: (state, action) => {
            state.isPromptBarActive = action.payload;
        },
    },
});

export const { setPromptBarActive } = promptBarSlice.actions;

export default promptBarSlice.reducer;